const servicealblePinCodes = [
    "98881",
    "4111",
    "413312",
    "312312",
    "312312",
    "312312325",
    "6765",
    "3123167",
    "912",
    "14661",
    "39981",
    "146022",
];

export default servicealblePinCodes;
